import { loginStatus$ } from '../store/loginV2';
import { firstValueFrom, switchMap, take } from 'rxjs';
import { api } from '../api';
import { getTopics } from './topics';
import { LoginStatus } from '../../common/types';

const doPublishPresentation = api
    .path('/api/presentation/{presentationId}/pub')
    .method('put')
    .create();

export function publishPresentation(presentationId: string) {
    return firstValueFrom(
        loginStatus$.pipe(
            take(1),
            switchMap((loginStatus) => {
                if (loginStatus.status !== LoginStatus.LOGGED_IN) {
                    throw new Error(
                        'User is not logged in, cannot delete presentation'
                    );
                }
                return doPublishPresentation(
                    { presentationId },
                    {
                        headers: {
                            authorization: `Bearer ${loginStatus.token}`,
                        },
                    }
                );
            }),
            switchMap(() => {
                return getTopics();
            })
        )
    );
}
